import { Document, Page, Text, View, Image, StyleSheet, Font, Svg, Path, Link, render } from "@react-pdf/renderer";
import font from './Quicksand-VariableFont_wght.ttf';
import fontBold from './Quicksand-Bold.ttf';
import fontSemiBold from './Quicksand-SemiBold.ttf';
import fontItalic from './quicksand-italic.ttf';
import logo from './HALCOMPASS_OUTLINED_WHITE.png';
import bgLogo from './HA_WHITE_LOGO.png'
import { convertFromRaw } from "draft-js";


Font.register({ family: 'Quicksand', src: font });
Font.register({ family: 'Quicksand', src: fontBold, fontWeight: 'bold', fontStyle: 'normal' });
Font.register({ family: 'Quicksand', src: fontSemiBold, fontWeight: 'semibold', fontStyle: 'normal' });
Font.register({ family: 'Quicksand', src: fontItalic, fontStyle: 'italic' });

Font.registerHyphenationCallback(word => {//disable hyphenation
    return [word];
});

const COLOR_MAP = {
    'Tidak Bersedia': '#dc3545',
    'Asas': '#ff6366',
    'Berkemampuan': '#ffc757',
    // default/fallback
    'default': '#16864a'
};

const styles = StyleSheet.create({
    page: {
        fontFamily: 'Quicksand',
        fontSize: '10',
        position: 'relative',
        paddingBottom:30
    },

    //----- Header -----//

    reportHeader: {
        backgroundColor: '#16864a',
        marginBottom: 6,
        height: '100px',
        position: 'relative'
    },

    headerBgContainer: {
        position: 'absolute',
        top: 7,
        right: 10,
        width: '100%',
        height: '100%',
        alignItems: 'flex-end'
    },

    headerBgItem: {
        width: '80px',
        height: '90px',
        objectFit: 'contain',
        opacity: 0.2,
    },

    headerContentContainer: {
        justifyContent: 'flex-start',     // Align items to the left
        alignItems: 'center',              // Vertical centering
        flexDirection: 'row',
        position: 'relative',
        height: '100%',
        paddingLeft: 20,                   // Space from left edge
        gap: 20
    },

    headerContentLogo: {
        width: '200px',
        height: '70px',
        objectFit: 'contain',
        backgroundColor: 'white',
        borderRadius: '15px',
        padding: 10
    },

    headerContentText: {
        flexDirection: 'column',
        justifyContent: 'center',
        color: 'white',
        fontWeight: 'bold',
        fontSize: '40',
    },

    //----- Upper Initial Report -----//

    sectionBorder: {
        border: '2px solid black',
        padding: 8,
        borderRadius: '20px'
    },

    rankingText: {
        marginHorizontal: 5,
        fontWeight: 'semibold'
    },

    reportResultContainer: {
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    },

    uppercaseText: {
        fontWeight: 'semibold',
        fontSize: '15',
        marginVertical: '6'
    },

    scoreGreenLabel: {
        borderRadius: '50px',
        backgroundColor: '#16864a',
        padding: '8',
        width: '100%',
        alignItems: 'center',
        color: 'white',
        fontWeight: 'semibold'
    },

    tableContainer: {
        width: '100%',
        fontSize: '12',
        border: '2px solid black',
    },

    tableContainerInner: {
        flexDirection: 'row',
        width: '100%'
    },

    tableHeader: {
        backgroundColor: '#0f4694',
        color: 'white',
        alignItems: 'center',
        padding: 8,
        fontWeight: 'bold'
    },

    tableScore: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        padding: '8',
        fontWeight: 'semibold',
        fontSize: '15'
    },

    tableYellow: {
        flex: 5,
        alignItems: 'flex-start',
        borderLeft: '2px solid black',
        padding: '9',
        backgroundColor: '#ffba00'
    },

    //----- Maklumat Syarikat -----//

    companyDetailContainer: {
        flexDirection: 'row',
        alignItems: 'stretch',
        width: '100%',
        marginTop: 8,
        gap: 3
    },

    companyDetailContainerBorder: {
        border: '2px solid black',
        padding: 6,
        borderRadius: '20px',
        flex: 1
    },

    greenTextBig: {
        color: '#239156',
        fontWeight: 'semibold',
        fontSize: '15',
        marginVertical: '6'
    },

    companyDetail: {
        border: '1px solid black',
        borderRadius: '30px',
        width: '85%',
        flexDirection: 'row',
        alignItems: 'center',
        padding: 3,
        marginBottom: 4
    },

    //----- Criteria Evaluation Section -----//

    criteriaName: {
        backgroundColor: '#0f4694',
        padding: 6,
        borderRadius: '30px',
        fontWeight: 'bold',
        color: 'white',
        alignSelf: 'flex-start',
        fontSize: '14'
    },

    evaluationHeader: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 4,
        width: '100%',
        padding: 12,
        borderBottom: '2px solid black',
        fontSize: '11'
    },

    //----- Footer -----//

    footerContainer: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
        height:50
        // alignItems:'flex-end',
        // justifyContent:'flex-end'
    },

    pageNumber: {
        textAlign: 'center',
        width: '100%',
        left: 0,
        position: 'absolute',
        bottom: 5,  // Match the bottom value with the View below
        zIndex: 1,
        fontWeight: 'bold'
    },

    confidentialText: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        position: 'absolute',
        bottom: 5,
        left: 0,
        zIndex: 0
    },

    copyrightText: {
        flexDirection: 'column',
        alignItems: 'flex-end',
        color: 'grey',
        fontSize: 8,
        paddingRight: 8,
        fontWeight: 'semibold'
    },
})


const convertDraftToReactPdfElements = (rawContent) => {
    const contentState = convertFromRaw(rawContent);
    const blocks = contentState.getBlocksAsArray();

    return blocks.map((block, blockIndex) => {
        const text = block.getText();
        const characterList = block.getCharacterList();
        const type = block.getType();

        // If block is empty, return a spacing element
        if (text.trim().length === 0) {
            return {
                blockStyle: { marginBottom: 0 }, // Adjust spacing as needed
                segments: [],
                blockIndex,
                isEmpty: true
            };
        }

        // Handle block-level styling for non-empty blocks
        const blockStyle = {};
        if (type === 'header-one') blockStyle.fontSize = 24;
        if (type === 'header-two') blockStyle.fontSize = 20;

        const segments = [];
        let current = { text: '', style: {} };

        for (let i = 0; i < text.length; i++) {
            const char = text[i];
            const styles = characterList.get(i).getStyle();

            const newStyle = {
                fontWeight: styles.has('BOLD') ? 'semibold' : 'normal',
                fontStyle: styles.has('ITALIC') ? 'italic' : 'normal',
                textDecoration: styles.has('UNDERLINE') ? 'underline' : 'none',
            };

            const styleChanged = JSON.stringify(newStyle) !== JSON.stringify(current.style);

            if (styleChanged && current.text) {
                segments.push({ ...current });
                current = { text: char, style: newStyle };
            } else {
                current.text += char;
                current.style = newStyle;
            }
        }
        if (current.text) segments.push(current);

        return { blockStyle, segments, blockIndex, isEmpty: false };
    });
};

export function HalCompassReportGenerator(props) {

    const plainText = convertDraftToReactPdfElements(props.selectedReportData.selectedRanking.action);

    return (
        <Document>
            <Page orientation="portrait" size={'A4'} style={styles.page} >

                <View fixed style={styles.reportHeader}>{/*Header*/}

                    {/* Background layer - place FIRST */}
                    <View style={styles.headerBgContainer}>
                        <Image style={styles.headerBgItem} src={bgLogo}></Image>
                    </View>

                    {/* Content layer - place SECOND */}
                    <View style={styles.headerContentContainer}>
                        <Image style={styles.headerContentLogo} src={logo}></Image>
                        <View style={styles.headerContentText}>
                            <Text >Penilaian</Text>
                            <Text style={{ marginTop: -10 }}>Kesediaan Halal</Text>
                        </View>
                    </View>

                </View>

                <View style={{ paddingVertical: 4,  paddingHorizontal: 8}}>
                    <View style={styles.sectionBorder}>
                        <View style={styles.reportResultContainer}>
                            <Text style={styles.uppercaseText}><Text style={{ color: '#16864a' }}>KEPUTUSAN </Text>KESEDIAAN HALAL</Text>
                            <View style={styles.scoreGreenLabel}><Text>Skor Kelayakan Permohonan Halal</Text></View>
                            <Text style={styles.uppercaseText}>JULAT SKOR:</Text>
                            <View style={{ flexDirection: 'row', fontSize: '12' }}>
                                {
                                    props.selectedReportData.rankings.map((ranking, rankingIndex) =>
                                        <Text key={rankingIndex} style={[styles.rankingText, { color: COLOR_MAP[ranking.title] || COLOR_MAP.default }]}>
                                            {ranking.minPercentage} - {ranking.maxPercentage} : {ranking.title}
                                        </Text>
                                    )
                                }
                            </View>

                            <View style={[styles.tableContainer, { marginVertical: '6' }]}>
                                {/* Table Header */}
                                <View style={[styles.tableContainerInner, { borderBottom: '2px solid black' }]}>
                                    <View style={[styles.tableHeader, { flex: 1 }]}><Text>Jumlah Skor</Text></View>
                                    <View style={[styles.tableHeader, { flex: 5, borderLeft: '2px solid black' }]}><Text>Tahap Kesediaan</Text></View>
                                </View>
                                <View style={styles.tableContainerInner}>
                                    <View style={styles.tableScore}>
                                        <Text>{props.selectedReportData.percentageScore}</Text>
                                    </View>
                                    <View style={styles.tableYellow}>
                                        <Text>
                                            Tahap kesediaan yang
                                            {' '}
                                            <Text style={{ fontWeight: 'semibold' }}>
                                                {props.selectedReportData.selectedRanking.title.toUpperCase()}
                                            </Text>
                                            {'.\n'}
                                            {props.selectedReportData.selectedRanking.description}
                                        </Text>
                                    </View>
                                </View>
                            </View>

                            <View style={[styles.tableContainer, { marginVertical: '6' }]}>
                                <View style={[styles.tableHeader, { borderBottom: '2px solid black' }]}>
                                    <Text>Tindakan Selanjutnya</Text>
                                </View>
                                <View style={{ padding: '8' }}>
                                    {plainText.map(({ blockStyle, segments, blockIndex, }) => {
                                        return (
                                            <Text key={blockIndex} style={{ ...blockStyle }}>
                                                {segments.map((seg, i) => (
                                                    <Text key={i} style={seg.style}>{seg.text}</Text>
                                                ))}
                                            </Text>
                                        )
                                    })}
                                </View>
                            </View>
                        </View>
                    </View>

                    <View style={styles.companyDetailContainer}>
                        <View style={styles.companyDetailContainerBorder}>
                            <View style={{ alignItems: 'center' }}>
                                <Text style={styles.greenTextBig}>
                                    MAKLUMAT SYARIKAT
                                </Text>
                                <View style={styles.companyDetail}>
                                    <Svg width={12} height={12} viewBox="0 0 512 512">
                                        <Path d="M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z" fill="#16864a" />
                                    </Svg>
                                    <Text style={{ marginLeft: 4 }}>{props.formattedDate} {props.formattedTime}</Text>
                                </View>
                                <View style={styles.companyDetail}>
                                    <Svg width={12} height={12} viewBox="0 0 512 512">
                                        <Path d="M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0z" fill="#16864a" />
                                        {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d=""/></svg> */}
                                    </Svg>
                                    <Text style={{ marginLeft: 4 }}>{props.selectedReportData.companyProfile.name}</Text>
                                </View>
                                <View style={styles.companyDetail}>
                                    <Svg width={12} height={12} viewBox="0 0 496 512">
                                        <Path
                                            d="M351.9 280l-190.9 0c2.9 64.5 17.2 123.9 37.5 167.4 11.4 24.5 23.7 41.8 35.1 52.4 11.2 10.5 18.9 12.2 22.9 12.2s11.7-1.7 22.9-12.2c11.4-10.6 23.7-28 35.1-52.4 20.3-43.5 34.6-102.9 37.5-167.4zM160.9 232l190.9 0C349 167.5 334.7 108.1 314.4 64.6 303 40.2 290.7 22.8 279.3 12.2 268.1 1.7 260.4 0 256.4 0s-11.7 1.7-22.9 12.2c-11.4 10.6-23.7 28-35.1 52.4-20.3 43.5-34.6 102.9-37.5 167.4zm-48 0C116.4 146.4 138.5 66.9 170.8 14.7 78.7 47.3 10.9 131.2 1.5 232l111.4 0zM1.5 280c9.4 100.8 77.2 184.7 169.3 217.3-32.3-52.2-54.4-131.7-57.9-217.3L1.5 280zm398.4 0c-3.5 85.6-25.6 165.1-57.9 217.3 92.1-32.7 159.9-116.5 169.3-217.3l-111.4 0zm111.4-48C501.9 131.2 434.1 47.3 342 14.7 374.3 66.9 396.4 146.4 399.9 232l111.4 0z"
                                            fill="#16864a"
                                        />
                                    </Svg>
                                    <Link
                                        src={
                                            props.selectedReportData.companyProfile.website.startsWith('http')
                                                ? props.selectedReportData.companyProfile.website
                                                : 'https://' + props.selectedReportData.companyProfile.website
                                        }
                                        style={{ marginLeft: 4, textDecoration: 'none', color: 'black' }}
                                    >
                                        {props.selectedReportData.companyProfile.website}
                                    </Link>
                                </View>
                                <View style={styles.companyDetail}>
                                    <Svg width={12} height={12} viewBox="0 0 512 512">
                                        <Path d="M224 248a120 120 0 1 0 0-240 120 120 0 1 0 0 240zm-29.7 56C95.8 304 16 383.8 16 482.3 16 498.7 29.3 512 45.7 512l356.6 0c16.4 0 29.7-13.3 29.7-29.7 0-98.5-79.8-178.3-178.3-178.3l-59.4 0z" fill="#16864a" />
                                    </Svg>
                                    <Text style={{ marginLeft: 4 }}>{props.selectedReportData.userFullName}</Text>
                                </View>
                                <View style={styles.companyDetail}>
                                    <Svg width={12} height={12} viewBox="0 0 512 512">
                                        <Path d="M160.2 25C152.3 6.1 131.7-3.9 112.1 1.4l-5.5 1.5c-64.6 17.6-119.8 80.2-103.7 156.4 37.1 175 174.8 312.7 349.8 349.8 76.3 16.2 138.8-39.1 156.4-103.7l1.5-5.5c5.4-19.7-4.7-40.3-23.5-48.1l-97.3-40.5c-16.5-6.9-35.6-2.1-47 11.8l-38.6 47.2C233.9 335.4 177.3 277 144.8 205.3L189 169.3c13.9-11.3 18.6-30.4 11.8-47L160.2 25z" fill="#16864a" />
                                    </Svg>
                                    {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M160.2 25C152.3 6.1 131.7-3.9 112.1 1.4l-5.5 1.5c-64.6 17.6-119.8 80.2-103.7 156.4 37.1 175 174.8 312.7 349.8 349.8 76.3 16.2 138.8-39.1 156.4-103.7l1.5-5.5c5.4-19.7-4.7-40.3-23.5-48.1l-97.3-40.5c-16.5-6.9-35.6-2.1-47 11.8l-38.6 47.2C233.9 335.4 177.3 277 144.8 205.3L189 169.3c13.9-11.3 18.6-30.4 11.8-47L160.2 25z"/></svg> */}
                                    <Text style={{ marginLeft: 4 }}>{props.selectedReportData.companyProfile.phoneNumber}</Text>
                                </View>
                                <View style={styles.companyDetail}>
                                    <Svg width={12} height={12} viewBox="0 0 640 512">
                                        <Path d="M320 16a104 104 0 1 1 0 208 104 104 0 1 1 0-208zM96 88a72 72 0 1 1 0 144 72 72 0 1 1 0-144zM0 416c0-70.7 57.3-128 128-128 12.8 0 25.2 1.9 36.9 5.4-32.9 36.8-52.9 85.4-52.9 138.6l0 16c0 11.4 2.4 22.2 6.7 32L32 480c-17.7 0-32-14.3-32-32l0-32zm521.3 64c4.3-9.8 6.7-20.6 6.7-32l0-16c0-53.2-20-101.8-52.9-138.6 11.7-3.5 24.1-5.4 36.9-5.4 70.7 0 128 57.3 128 128l0 32c0 17.7-14.3 32-32 32l-86.7 0zM472 160a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zM160 432c0-88.4 71.6-160 160-160s160 71.6 160 160l0 16c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-16z" fill="#16864a" />
                                    </Svg>
                                    {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><!--!Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M320 16a104 104 0 1 1 0 208 104 104 0 1 1 0-208zM96 88a72 72 0 1 1 0 144 72 72 0 1 1 0-144zM0 416c0-70.7 57.3-128 128-128 12.8 0 25.2 1.9 36.9 5.4-32.9 36.8-52.9 85.4-52.9 138.6l0 16c0 11.4 2.4 22.2 6.7 32L32 480c-17.7 0-32-14.3-32-32l0-32zm521.3 64c4.3-9.8 6.7-20.6 6.7-32l0-16c0-53.2-20-101.8-52.9-138.6 11.7-3.5 24.1-5.4 36.9-5.4 70.7 0 128 57.3 128 128l0 32c0 17.7-14.3 32-32 32l-86.7 0zM472 160a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zM160 432c0-88.4 71.6-160 160-160s160 71.6 160 160l0 16c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-16z"/></svg> */}
                                    <Text style={{ marginLeft: 4 }}>{props.selectedReportData.companyProfile.staffTotal}</Text>
                                </View>
                                <View style={styles.companyDetail}>
                                    <Svg width={12} height={12} viewBox="0 0 512 512">
                                        <Path d="M200 48l112 0c4.4 0 8 3.6 8 8l0 40-128 0 0-40c0-4.4 3.6-8 8-8zm-56 8l0 40-80 0C28.7 96 0 124.7 0 160l0 96 512 0 0-96c0-35.3-28.7-64-64-64l-80 0 0-40c0-30.9-25.1-56-56-56L200 0c-30.9 0-56 25.1-56 56zM512 304l-192 0 0 16c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-16-192 0 0 112c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-112z" fill="#16864a" />
                                    </Svg>
                                    {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M200 48l112 0c4.4 0 8 3.6 8 8l0 40-128 0 0-40c0-4.4 3.6-8 8-8zm-56 8l0 40-80 0C28.7 96 0 124.7 0 160l0 96 512 0 0-96c0-35.3-28.7-64-64-64l-80 0 0-40c0-30.9-25.1-56-56-56L200 0c-30.9 0-56 25.1-56 56zM512 304l-192 0 0 16c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-16-192 0 0 112c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-112z"/></svg> */}
                                    <Text style={{ marginLeft: 4 }}>{props.selectedReportData.companyProfile.shift} SHIFT(S)</Text>
                                </View>
                                <View style={styles.companyDetail}>
                                    <Svg width={12} height={12} viewBox="0 0 512 512">
                                        <Path d="M32 32C14.3 32 0 46.3 0 64L0 432c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-279.8c0-18.2-19.4-29.7-35.4-21.1l-156.6 84.3 0-63.2c0-18.2-19.4-29.7-35.4-21.1L128 215.4 128 64c0-17.7-14.3-32-32-32L32 32z" fill="#16864a" />
                                        {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M32 32C14.3 32 0 46.3 0 64L0 432c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-279.8c0-18.2-19.4-29.7-35.4-21.1l-156.6 84.3 0-63.2c0-18.2-19.4-29.7-35.4-21.1L128 215.4 128 64c0-17.7-14.3-32-32-32L32 32z"/></svg> */}
                                    </Svg>
                                    <Text style={{ marginLeft: 4, }}>{props.selectedReportData.companyProfile.industrialCategory}</Text>
                                </View>
                                <View style={styles.companyDetail}>
                                    <Svg width={12} height={12} viewBox="0 0 512 512">
                                        <Path d="M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-277.5c0-17-6.7-33.3-18.7-45.3L258.7 18.7C246.7 6.7 230.5 0 213.5 0L64 0zM325.5 176L232 176c-13.3 0-24-10.7-24-24L208 58.5 325.5 176z" fill="#16864a" />
                                    </Svg>
                                    {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-277.5c0-17-6.7-33.3-18.7-45.3L258.7 18.7C246.7 6.7 230.5 0 213.5 0L64 0zM325.5 176L232 176c-13.3 0-24-10.7-24-24L208 58.5 325.5 176z"/></svg> */}
                                    <Text style={{ marginLeft: 4 }}>{props.selectedReportData.selectedScheme.name}</Text>
                                </View>
                            </View>
                        </View>
                        <View style={[styles.companyDetailContainerBorder, { justifyContent: 'space-around', alignItems: 'center' }]}>
                            <View style={{ alignItems: 'center' }}>
                                <View style={{ marginBottom: 15 }}>
                                    <Text style={{ fontWeight: 'semibold', fontSize: '15', }}>
                                        Keputusan Skor Kriteria Penilaian
                                    </Text>
                                </View>
                                <View>
                                    {props.selectedReportData.selectedAnswers.map((selectedAnswer, selectedAnswerIndex) =>
                                        <View key={selectedAnswerIndex} style={{ flexDirection: 'row', fontSize: '11' }}>
                                            <Text style={{ marginRight: 8 }}>•</Text>
                                            <Text><Text style={{ fontWeight: 'semibold' }}> {selectedAnswer.criteria}</Text>: {selectedAnswer.percentageCreteriaScore}%</Text>
                                        </View>)
                                    }
                                </View>
                            </View>
                            <Text style={{ textAlign: 'justify' }}>
                                <Text style={{ fontWeight: 'semibold' }}>Catatan:</Text> Keputusan skor mengikut krieria ini bertujuan untuk menerangkan tahap pematuhan
                                terhadap setiap keperluan utama dalam
                                pensijilan halal. Peratusan yang ditunjukkan
                                mencerminkan sejauh mana organisasi telah
                                bersedia untuk memenuhi kehendak pensijilan
                                tersebut
                            </Text>

                        </View>
                    </View>
                </View>

                {props.selectedReportData.selectedAnswers.map((selectedAnswer, selectedAnswersIndex) =>
                (<View key={selectedAnswersIndex}  break>
                    

                    <View style={{ padding: 8 }} >
                        <Text style={styles.criteriaName} fixed>{selectedAnswer.criteria}</Text>

                        <View style={{ alignItems: 'center' }} fixed>
                            {/* Table Header (only once) */}
                            <View style={[styles.evaluationHeader, { borderTop: '2px solid black', fontWeight: 'bold' }]}>
                                <View style={{ flex: 2, textAlign: 'center' }}><Text>KRITERIA PENILAIAN</Text></View>
                                <View style={{ flex: 2, textAlign: 'center' }}><Text>PILIHAN JAWAPAN</Text></View>
                                <View style={{ flex: 8, textAlign: 'center' }}><Text>ULASAN PENILAIAN</Text></View>
                            </View>
                        </View>

                        {/* Table Body */}
                        {selectedAnswer.answers.map((userAnswers, userAnswersIndex) => {
                            let plainReviewText = null;
                            let isDraftContent = false;

                            // Check if it's Draft.js content
                            if (
                                userAnswers.review &&
                                typeof userAnswers.review === 'object' &&
                                userAnswers.review.blocks &&
                                Array.isArray(userAnswers.review.blocks)
                            ) {
                                try {
                                    plainReviewText = convertDraftToReactPdfElements(userAnswers.review);
                                    isDraftContent = true;
                                } catch (error) {
                                    console.error('Error converting Draft.js content:', error);
                                    // Fallback to plain text if conversion fails
                                    plainReviewText = JSON.stringify(userAnswers.review);
                                    isDraftContent = false;
                                }
                            } else if (typeof userAnswers.review === 'string') {
                                plainReviewText = userAnswers.review;
                                isDraftContent = false;
                            }

                            return (
                                <View key={userAnswersIndex} style={{ alignItems: 'center', }} wrap={false}>
                                    <View style={[styles.evaluationHeader, { padding: 8, fontSize: '10' }]} >
                                        <View style={{ flex: 2 }}>
                                            <Text style={{ textAlign: 'center', fontWeight: 'bold' }}>{userAnswers.question}</Text>
                                        </View>
                                        <View style={{ flex: 2, marginHorizontal: 15 }}>
                                            <Text style={{ textAlign: 'center' }}>{userAnswers.answer}</Text>
                                        </View>
                                        <View style={{ flex: 8, justifyContent: 'space-between', textAlign: 'justify' }}>
                                            <View>
                                                <Text style={{ fontWeight: 'bold', marginBottom: '12' }}>STATUS: {userAnswers.status.toUpperCase()}</Text>
                                            </View>

                                            {/* Render Draft.js styled content */}
                                            {isDraftContent && plainReviewText && plainReviewText.map(({ blockStyle, segments, blockIndex, isEmpty }) => {

                                                if (isEmpty) {
                                                    return <View key={blockIndex} style={{ height: 12 }} />;
                                                }

                                                return (

                                                    <View key={blockIndex} style={{ marginBottom: 8, ...blockStyle }}>
                                                        <Text>
                                                            {segments.map((seg, i) => (
                                                                <Text key={i} style={seg.style}>{seg.text}</Text>
                                                            ))}
                                                        </Text>
                                                    </View>
                                                )
                                            })}

                                            {/* Render plain text */}
                                            {!isDraftContent && plainReviewText && (
                                                <View>
                                                    <Text style={{ marginBottom: '8' }}>{plainReviewText}</Text>
                                                </View>
                                            )}

                                            <View>
                                                <Text style={{ fontWeight: 'bold' }}>{userAnswers.reference}</Text>
                                            </View>
                                        </View>
                                    </View>
                                </View>
                            );
                        })}

                    </View>

                </View>))
                }

                <View style={{ justifyContent: 'center', alignItems: 'center' }} render={({ pageNumber, totalPages }) => (
                    pageNumber === totalPages ?
                        (<Text style={{ fontWeight: 'bold' }}>"INI ADALAH CETAKAN KOMPUTER DAN TIDAK MEMERLUKAN TANDATANGAN"</Text>)
                        :
                        ('')
                )}>
                </View>
                <View fixed style={styles.footerContainer}>
                    <Text
                        style={styles.pageNumber}
                        render={({ pageNumber, totalPages }) => (
                            `${pageNumber} / ${totalPages}`
                        )}
                    />

                    <View style={styles.confidentialText} >
                        <Text style={{ fontWeight: 'bold', paddingLeft: 16 }} >Sulit</Text>

                        <View style={styles.copyrightText}>
                            <Text>Hak Milik Terpelihara</Text>
                            <Text>GAE Resources Sdn Bhd (Halal Academy) 2025</Text>
                        </View>
                    </View>
                </View>
                {/* </View> */}

            </Page>
        </Document>
    )
}